import React from 'react'
import values from 'mout/object/values'
import checkSubjectMatch from '../../../../helpers/assessment/checkSubjectMatch';
import HeatMarker from './HeatMarker'
import getHeat from '../../../../helpers/assessment/getHeat';
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText';

export default function StaminaTwoSubjects ({subjects, byItem, assessmentSubtests}) {
  const containerStyles = {
    ELA: {width: '400px', float: 'left', top: '55px', left: '57px', position: 'absolute'},
    STEM: {width: '400px', float: 'left', top: '96px', left: '57px', position: 'absolute'},
  }
  const containerClass = {
    ELA: 'englishAndReading',
    STEM: 'mathAndScience',
  }
  const headerText = {
    ELA: 'English and Reading',
    STEM: 'Math and Science',
  }
  let heatMaps = []
  const subtests = sortByPropText(values(assessmentSubtests), 'index')
  subtests.forEach((subtest) => {
    if (checkSubjectMatch(subtest, subjects)) {
      const subtestId = subtest.setId
      const nameLC = subtest.displayName.toLowerCase()
      const styles = {
        english: {width: '258px'},
        math: {width: '240px'},
        reading: {width: '138px', marginLeft: '258px'},
        science: {width: '161px', marginLeft: '240px'},
      }
      const items = sortByPropText(values(byItem[subtestId]), 'index')
      heatMaps.push(
        <div 
          className={`subjectBar ${nameLC}Bar`}
          style={styles[nameLC]}
          key={`st2subjectBar ${nameLC}Bar`}
        >
          {subtest.displayName}
        </div>
      )
      items.forEach((item, m) => {
        let heat = getHeat(item.raw, item.possible)
        heatMaps.push(
          <HeatMarker heat={heat} itemNumber={m + 1} key={`st2${item.itemId}`}/>
        )
      })
      // heatMaps.push(<div className={`${nameLC}Bar`} key={`st2${nameLC}Bar`}></div>)
    }
  })


  return (
    <div className={containerClass[subjects]} style={containerStyles[subjects]}>
      <h3 style={{fontSize: '8px', marginBottom: '1px'}}>{headerText[subjects]}</h3>
      <ol className='heatMap'>
        {heatMaps}
      </ol>
    </div>
  ) 
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/StaminaTwoSubjects.js